import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import apiClient from '@/services/apiClient';
import { fmtQ } from '@/components/po/PoLinePicker';

/** Open POs past their expected delivery date that still have qty to come — most late first. */
export const LatePos = () => {
  const [pos, setPos] = useState(null);
  useEffect(() => { apiClient.get('/po-followup/late').then((r) => setPos(r.data.pos)).catch(() => setPos([])); }, []);
  if (!pos) return <Loader2 className="mx-auto my-10 h-6 w-6 animate-spin text-gray-400" />;
  if (!pos.length) return <p className="py-10 text-center text-sm text-gray-500" data-testid="po-late-empty">No open Purchase Order is past its expected delivery date.</p>;
  return (
    <div className="overflow-x-auto" data-testid="po-late-table">
      <Table>
        <TableHeader><TableRow>
          <TableHead>PO</TableHead><TableHead>Supplier</TableHead><TableHead>Section</TableHead><TableHead>Expected delivery</TableHead>
          <TableHead>Late by</TableHead><TableHead>Still to come</TableHead><TableHead>Status</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {pos.map((p) => (
            <TableRow key={p.po_id} data-testid={`po-late-row-${p.po_id}`}>
              <TableCell><Link to={`/po/${p.po_id}`} className="font-mono text-xs text-blue-700 hover:underline">{p.po_number}</Link><div className="text-[10px] text-gray-400">{p.po_date}</div></TableCell>
              <TableCell className="text-sm">{p.vendor_name}</TableCell>
              <TableCell className="text-xs">{p.section_name}</TableCell>
              <TableCell className="text-xs">{p.expected_delivery_date}</TableCell>
              <TableCell><Badge variant="outline" className="border-rose-300 bg-rose-100 text-rose-700" data-testid={`po-late-days-${p.po_id}`}>{p.days_late} day{p.days_late === 1 ? '' : 's'}</Badge></TableCell>
              <TableCell className="text-sm font-semibold text-amber-700 tabular-nums">{p.balance.map((b) => `${fmtQ(b.qty)} ${b.unit}`).join(' · ')}</TableCell>
              <TableCell className="text-[11px] font-semibold text-gray-600">{p.po_status.replace('_', ' ')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
